import {
  StickyTableHead,
  StickyTableHeader,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@/components/_ui/table";
import { flexRender, Row, type RowData } from "@tanstack/react-table";

import { isSectionRow, isSubSectionRow, SectionData, SubSectionData, TSectionData } from "../datatable-types";
import { useDatatableContext } from "../use-datatable-context";

import { DatatableListRow } from "./datatable-list-row";
import { DatatableListSectionRow } from "./datatable-list-section-row";
import { DatatableListSubSectionRow } from "./datatable-list-subsection-row";

export function DatatableList<TData extends RowData>() {
  const { table, state } = useDatatableContext<TSectionData<TData>>();
  const { showColumnHeaders } = state;

  const rows = table.getRowModel().rows;
  const columns = table.getAllColumns();

  return (
    <StickyTableHeader containerClassName="h-full">
      {showColumnHeaders && (
        <TableHeader className="[&_tr]:border-none">
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <StickyTableHead key={header.id}>
                  <>
                    {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                    <div className="shadow-sm absolute bottom-0 left-0 right-0 border-b"></div>
                  </>
                </StickyTableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>
      )}

      <TableBody className="w-full">
        {rows?.length > 0 ? (
          rows.map((row, i) => {
            if (row.depth === 0 && isSectionRow<TData>(row.original)) {
              return <DatatableListSectionRow<TData> key={i} row={row as unknown as Row<SectionData<TData>>} />;
            }

            if (row.depth === 1 && isSubSectionRow<TData>(row.original)) {
              return <DatatableListSubSectionRow<TData> key={i} row={row as unknown as Row<SubSectionData<TData>>} />;
            }

            return <DatatableListRow key={i} row={row} />;
          })
        ) : (
          <TableRow>
            <TableCell colSpan={columns.length} className="h-24 text-center">
              Keine Ergebnisse gefunden.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </StickyTableHeader>
  );
}
